import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';

const STORAGE_KEY = 'sa_cookie_banner_dismissed_v1';

/**
 * Banner informativo per i cookie tecnici (no consenso GDPR richiesto perché
 * usiamo solo cookie essenziali alla sessione). Discreto, in fondo a destra.
 */
const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      // Mostra dopo 600ms per non disturbare il primo paint
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 right-4 max-w-sm bg-white border border-slate-200 shadow-lg rounded-lg p-4 z-50"
      role="dialog"
      aria-live="polite"
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1 text-sm text-slate-700">
          <p className="font-semibold text-slate-900 mb-1">Cookie tecnici</p>
          <p className="text-xs text-slate-600">
            Usiamo solo cookie essenziali per la tua sessione di accesso. Nessun tracker, nessun
            cookie di terze parti.{' '}
            <Link to="/privacy" className="text-blue-600 underline" data-testid="cookie-privacy-link">
              Maggiori info
            </Link>
            .
          </p>
          <button
            onClick={dismiss}
            className="mt-3 text-xs font-medium bg-slate-900 text-white px-3 py-1.5 rounded hover:bg-slate-800"
            data-testid="cookie-banner-dismiss"
          >
            Ho capito
          </button>
        </div>
        <button
          onClick={dismiss}
          className="text-slate-400 hover:text-slate-600"
          aria-label="Chiudi"
          data-testid="cookie-banner-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
